@let state = presenter.viewState();

<spa-card [class.spa-card--outlined]="state.appearance === 'outlined'">
  @if (state.contentTemplate) {
    <ng-container *ngTemplateOutlet="$any(state.contentTemplate)" />
  }
</spa-card>
